<template>
    <div>
        <div>
            <el-tabs class="tabs" v-model="tabIndex" stretch>
                <el-tab-pane label="企业荣誉" name="0">
                    <div class="looks">
                        <div class="lookLists">
                            <div class="item" v-for="(item, index) in zslist">
                                <div class="coversLook" @click="onShowImg(item.imgUrl)">
                                    <img class="horizontal" :src="item.imgUrl" alt="">
                                    <div class="lookName"></div>
                                </div>
                                <img class="listBack" v-if="index % 2 === 0"
                                    src="https://www.dpark.com.cn/ycxxFileUrl/wxapplet/looks/bookshelf2.png" alt="">
                            </div>

                        </div>
                    </div>



                </el-tab-pane>
                <el-tab-pane label="获奖作品" name="1">
                    <div class="looks">
                        <div class="lookLists">
                            <div class="item" v-for="(item, index) in jxlist">
                                <div class="coversLook" @click="onShowImg(item.imgUrl)">
                                    <img class="horizontal" :src="item.imgUrl" alt="">
                                    <div class="lookName"></div>
                                </div>
                                <img class="listBack" v-if="index % 2 === 0"
                                    src="https://www.dpark.com.cn/ycxxFileUrl/wxapplet/looks/bookshelf2.png" alt="">
                            </div>

                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>



        <div class="showImg" v-show="show">
            <div class="delIcon" @click="show = false">
                <i class="el-icon-circle-close"></i>
            </div>

            <div class="contimg">
                <img :src="showImg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            tabIndex: '0',
            show: false,
            showImg: "",
            jxlist: [],
            zslist: []



        }
    },
    mounted() {
        axios.get('https://www.dpark.com.cn/ycxxFileUrl/wxapplet/certificates/certificate.json').then(res => {
            this.jxlist = res.data.jxlist;
            this.zslist = res.data.zslist;

        })
    },
    methods: {
        onShowImg(url) {
            this.showImg = url;
            this.show = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.showImg {
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 99;


    .delIcon {
        position: fixed;
        top: 120px;
        right: 30px;
        z-index: 1000;

        i {
            font-size: 50px;
            color: #fff;
        }
    }

    .contimg {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100vh;

        img {
            width: 100%;
        }
    }
}

.looks {
    width: 100%;
    height: calc(100vh - 90px);
    background-image: url('https://www.dpark.com.cn/ycxxFileUrl/wxapplet/looks/back.png');
    // background-color: #f2f2f2;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    overflow-y: auto;

    .lookLists {
        display: grid;
        grid-template-columns: repeat(2, 46%);
        grid-row-gap: 90px;
        grid-column-gap: 7%;
        align-items: end;
        padding: 0 60px;
        padding-top: 100px;

        .item {
            position: relative;

            .coversLook {
                width: 100%;
                min-height: 100px;
                position: relative;

                .lookName {
                    background: rgba($color: #000000, $alpha: 0.7);
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    font-size: 20px;
                    padding: 0 6px;
                    box-sizing: border-box;
                    color: #fff;
                    text-align: center;
                }

                img {
                    width: 100%;
                    height: auto;
                    border: 6px solid #606266;
                    box-shadow: 0 0 4px 6px #2d1b00;
                }

            }

            .listBack {
                position: absolute;
                width: 712px;
                height: 111px;
                bottom: -110px;
                z-index: 3;
                left: -40px;
            }
        }
    }
}



::v-deep .tabs {
    position: fixed;
    top: 0;
    width: 100%;

    .el-tabs__header {
        margin-bottom: 10px;
        background-color: #fff;

        .el-tabs__nav-wrap {
            padding: 0 20px;
        }
    }

    .el-tabs__item {
        height: 90px;
        line-height: 90px;
        font-size: 28px;
    }

    .el-collapse-item__header {
        height: 90px;

        .title {
            display: flex;
            align-items: center;
            padding: 0 20px;
            font-size: 28px;

            img {
                width: 50px;
            }

            span {
                margin-left: 20px;
            }
        }

    }
}
</style>